<template>
    <div>
        <h6 class="proxima-nova-bold mb-3">Upcoming Invoices</h6>
        <table class="client1-table table-format set_column_width table table-striped table-bordered dt-responsive nowrap" v-bind:id=id style="width:100% !important">
            <thead>
            <tr>
                <th v-if="showClient" scope="col" style="width: 200px">Client</th>
                <th v-if="showOrder" scope="col">Order</th>
                <th scope="col">Invoice Date</th>
                <th scope="col">Period</th>
                <th scope="col">Rental Fee</th>
                <th scope="col">Discount</th>
                <th scope="col">Ads Package</th>
                <th scope="col">Total</th>
                <th scope="col" class="text-center">Skipped</th>
                <th scope="col">Edited By</th>

            </tr>
            </thead>
            <tbody>
            <tr v-for="(invoice, idx) in invoices" style="position: relative">
                <td v-if="showClient">
                    {{ organizations[invoice.order.client.org_id].name }}
                </td>
                <td v-if="showOrder">
                    <a :href="`/orders/${invoice.order.number}`">{{ invoice.order.number }}</a>
                </td>
                <td>
                    {{ invoice.invoice_date | formatDateYmd }}
                    <button v-if="invoice.id === tempInvoice.id" type="button" @click="submit(invoice)" class="btn btn-primary">Submit</button>
                    <button v-if="invoice.id === tempInvoice.id" type="button" @click="cancel()" class="btn">Cancel</button>
                    <button v-else type="button" @click="edit(invoice)" class="btn btn-primary" style="display: block">Edit</button>
                </td>
                <td>
                    {{ invoice.invoice_period_start | formatDateYmd }} - {{ invoice.invoice_period_end | formatDateYmd }}
                </td>
                <td>
                    <input v-if="invoice.id === tempInvoice.id" v-model="tempInvoice.rental_fee" class="form-control" />
                    <span v-else>{{ invoice.rental_fee }} {{ invoice.order.currency }}</span>
                </td>
                <td>
                    <input v-if="invoice.id === tempInvoice.id" v-model="tempInvoice.discount" class="form-control" />
                    <span v-else>{{ invoice.discount }}%</span>
                </td>
                <td>
                    <input v-if="invoice.id === tempInvoice.id" v-model="tempInvoice.ads_package" class="form-control" />
                    <span v-else>{{ invoice.ads_package }} {{ invoice.order.currency }}</span>
                </td>
                <td>
                    <span style="display: block">{{ invoice.id === tempInvoice.id ? getTotal(tempInvoice, true) : getTotal(invoice, true) }} {{ invoice.order.currency }}</span>
                    <span>{{ invoice.id === tempInvoice.id ? getTotal(tempInvoice) : getTotal(invoice) }} {{ invoice.order.currency }} (inc. VAT)</span>
                </td>
                <td class="text-center">
                    <input type="checkbox" v-if="invoice.id === tempInvoice.id" v-model="tempInvoice.is_skipped" style="margin-top: 12px;"/>
                    <input v-else type="checkbox" v-model="invoice.is_skipped" style="margin-top: 12px;" onclick="return false;" />
                </td>
                <td>
                    <span style="display: block">{{ invoice.approver && invoice.approver.hasOwnProperty('name') ? invoice.approver.name : '' }}</span>
                    <span v-if="invoice.approved_at" style="white-space: nowrap;">{{ invoice.approved_at | formatDate }}</span>
                </td>

            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from 'moment';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import 'datatables.net-responsive-dt'

export default {
    name: 'invoice-drafts',
    props: ['invoices', 'organizations', 'showClient', 'showOrder', 'directDebit','id'],
    data: function () {
        return {
            tempInvoice: {
                discount: 0,
            },
        };
    },
    mounted() {
        if (!$.fn.DataTable.isDataTable('#upcom-invoice') )
        {
            $('#upcom-invoices').DataTable({responsive: true});
        }
    },
    updated(){
    },
    watch: {
        tempInvoice: {
            handler: function (newVal, oldVal) {
                if (newVal.hasOwnProperty('discount')) {
                    if (isNaN(newVal.discount)) {
                        newVal.discount = 0;
                    }
                    if (newVal.discount > 100) {
                        newVal.discount = 100;
                    } else if (newVal.discount < 0) {
                        newVal.discount = 0;
                    }
                }
                if (newVal.hasOwnProperty('rental_fee')) {
                    if (isNaN(newVal.rental_fee)) {
                        newVal.rental_fee = 0;
                    }
                    if (newVal.rental_fee < 0) {
                        newVal.rental_fee = 0;
                    }
                }
                if (newVal.hasOwnProperty('ads_package')) {
                    if (isNaN(newVal.ads_package)) {
                        newVal.ads_package = 0;
                    }
                    if (newVal.ads_package < 0) {
                        newVal.ads_package = 0;
                    }
                }
            },
            deep: true
        },
    },
    methods: {
        edit(invoice) {
            this.tempInvoice = JSON.parse(JSON.stringify(invoice));
        },
        submit(invoice) {
            this.$http.put(`/invoices/${this.tempInvoice.id}`, {
                rentalFee: this.tempInvoice.rental_fee,
                discount: this.tempInvoice.discount,
                adsPackage: this.tempInvoice.ads_package,
                isSkipped: this.tempInvoice.is_skipped,
            }).then((res) => {
                invoice.rental_fee = this.tempInvoice.rental_fee;
                invoice.discount = this.tempInvoice.discount;
                invoice.ads_package = this.tempInvoice.ads_package;
                invoice.is_skipped = this.tempInvoice.is_skipped;
                invoice.approved_at = res.data.approved_at;
                invoice.approver = res.data.approver;
                this.tempInvoice = {
                    discount: 0,
                };
            }).catch((e) => {
                console.log(e);
            });
        },
        cancel() {
            this.tempInvoice = {
                discount: 0,
            };
        },
        approve(invoice) {
            this.$http.post(`/invoices/${invoice.id}/approve`, {}).then((res) => {
                invoice.approved_at = res.data.approved_at;
                invoice.approver = res.data.approver;
                this.$forceUpdate();
            }).catch((e) => {
                console.log(e);
            });
        },
        disapprove(invoice) {
            this.$http.post(`/invoices/${invoice.id}/disapprove`, {}).then((res) => {
                invoice.approver = null;
                this.$forceUpdate();
            }).catch((e) => {
                console.log(e);
            });
        },
        getVAT(order) {
            if (order.currency === 'SEK') {
                return 0.25;
            }
            if (order.currency === 'GBP') {
                return 0.20;
            }

            return NaN;
        },
        getTotal(invoice, skipVat) {
            const vat = skipVat && skipVat === true ? 0 : this.getVAT(invoice.order);
            const discount = invoice.discount / 100;
            const total = (1 + vat) * (invoice.rental_fee * (1 - discount) + invoice.ads_package * 1);
            return Math.round((total + Number.EPSILON) * 100) / 100;
        }
    },
    filters: {
        formatDateYmd(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        formatDate(date) {
            return moment(date).format('MMM Do HH:mm');
        }
    }
}
</script>
